import {z as zod} from "zod";
import {DATA_VIEWER_NULL_SENTINEL as NULL_SENTINEL} from "~/utilities/queries";

function isNullishColumnValueFromApi(item: unknown): boolean {
    if (item === null || item === undefined) {
        return true;
    }
    if (typeof item === "string") {
        const trimmed = item.trim();
        return trimmed === "" || trimmed === "-" || trimmed === NULL_SENTINEL;
    }
    return false;
}

/** Normalizes column-values API payloads into filter picker values; adds NULL_SENTINEL only when the API returned nullish entries alongside other values. */
export function normalizeColumnValuesFromApi(rawValues: Array<unknown>): Array<string> {
    if (rawValues.length === 0) {
        return [];
    }

    let hasNull = false;
    const values = new Set<string>();

    for (const item of rawValues) {
        if (isNullishColumnValueFromApi(item) === true) {
            hasNull = true;
            continue;
        }
        values.add(String(item));
    }

    if (values.size === 0) {
        return hasNull === true ? [NULL_SENTINEL] : [];
    }

    const sortedValues = Array.from(values).sort((left, right) => left.localeCompare(right));
    return hasNull === true ? [NULL_SENTINEL, ...sortedValues] : sortedValues;
}

export const columnValuesFromApiZodValidator = zod.array(zod.unknown()).transform(normalizeColumnValuesFromApi);
